import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import { TbEyeClosed } from "react-icons/tb";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { RiLockPasswordLine } from "react-icons/ri";
import { VscEye } from "react-icons/vsc";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";

const EditAdsCategories = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [withOutRefresh, setWithoutRefresh] = useState(false);
  const [editUser, setEditUser] = useState({
    company_name: "",
    license_number: "",
    ccode: "",
    email_id: "",
    mobile_number: "",
    address: "",
    password: "",
    status: null,
    stripe_id: "",
    card_brand: "",
    card_last_four: ""
  });
  const [formErrors, setFormErrors] = useState({});


  const [number, setNumber] = useState([]);
  const [defaultData, setDefaultData] = useState([])
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(() => {
    setShowOverlay(true);
    const getUser = async () => {
      try {
        const reqData = await fetch(
          `${process.env.REACT_APP_Baseurl}/admin/advertiser-edit/${id}`,
          { headers: headers }
        );
        const resData = await reqData.json();
        if (resData.status === true) {
          setEditUser(resData.Advertiser);
          setDefaultData((prev) => ({
            ...prev,
            country: resData?.Country,
            activeCurrency: resData?.activeCurrency,
          }));

          const cleanCcode = resData.Advertiser.ccode?.replace("+", "");
          const currentCountry = resData?.Country?.find(
            (country) => String(country.phonecode) === String(cleanCcode)
          );

          if (currentCountry) {
            setEditUser(prev => ({
              ...prev,
              ccode: currentCountry.phonecode
            }));
          }
          setShowOverlay(false);
        }
      } catch (error) {
        toast.error("Something went wrong while fetching data.");
      }
    };
    getUser();
  }, [id, withOutRefresh]);

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;
    setEditUser((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };


  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const validateForm = (editUser) => {
    const errors = {};

    const companyName = editUser.company_name?.trim();
    if (!companyName) {
      errors.company_name = "Advertiser name is required";
    } else if (companyName.length < 3) {
      errors.company_name = "Advertiser name must be at least 3 characters";
    } else if (companyName.length > 100) {
      errors.company_name = "Advertiser name must not exceed 100 characters";
    }

    const email = editUser.email_id?.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      errors.email_id = "Email ID is required";
    } else if (!emailRegex.test(email)) {
      errors.email_id = "Please enter a valid email address";
    }

    const mobile = String(editUser.mobile_number || "").trim();
    if (!mobile) {
      errors.mobile_number = "Mobile number is required";
    } else if (mobile.length > 15) {
      errors.mobile_number = "Mobile number must not exceed 15 characters";
    }
    if (!editUser?.ccode) {
      errors.ccode = "Country code is required";
    }
    return errors;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const errors = validateForm(editUser);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});

    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/advertiser-update/${id}`,
        {
          method: "PATCH",
          headers: headers,
          body: JSON.stringify(editUser),
        }
      );

      const resjson = await res.json();

      if (resjson.status === true) {
        toast.success(resjson.message);
        props.setApiresponsealert(resjson);
        props.setShowalert(true);
        setWithoutRefresh(prev => !prev);
      } else {
        props.setApiresponsealert(resjson);
        props.setShowalert(true);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while updating data.");
    } finally {
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      <AdminBackNavigation path="/advertisers" text="Back" />
      {showOverlay && <Response_Processing />}
      <AdminSaveHeader heading={"Edit Advertiser"} saveText={"Update"} saveMethod={handleUpdate} type="submit" />
      <FormContainer className="pb-5">
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={" "} />
            <MessageLabel text={"Advertiser Name"} className="mandatorySimple" />
            <AdminCustomInput type="text" name="company_name" value={editUser.company_name} onChange={handleInput} placeHolder={"Enter Advertiser Name"} id={"advertiser-name"} error={formErrors.company_name} />

            <MessageLabel text={"Email"} className="mandatorySimple" />
            <AdminCustomInput type="email" name="email_id" value={editUser.email_id} onChange={handleInput} placeHolder={"Enter Email"} id={"advertiser-email"} error={formErrors.email_id} />

            <MessageLabel text={"Password"} />
            <div className="position-relative">
              <input
                type={passwordType}
                name="password"
                value={isPasswordChanged ? editUser?.password : ""}
                onChange={(e) => {
                  if (e.target.value.trim() !== "") {  // Check if user is actually typing
                    setIsPasswordChanged(true);
                  }
                  setEditUser(prev => ({ ...prev, password: e.target.value }));
                }}
                id={"advertiser-password"}
                autoComplete="new-password" // Prevents autofill
                placeholder="Enter Password"
                className="rs-input py-3 px-5 form-control-lg custom-placeholder theme-text-color mb-3"
              />

              <button onClick={togglePassword} type="button" className="position-absolute passWordIcon bg-transparent">
                {passwordType === "password" ? <TbEyeClosed className="eyeClosed  text-dark" /> : <VscEye className="eyeOpen  text-dark" />}
              </button>
              <RiLockPasswordLine className="lockIcon position-absolute text-dark" />
            </div>

          </Wrapper>
        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text={" "} />
            <MessageLabel text={"Mobile Number"} className="mandatorySimple" />
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center justify-content-between">
                <div className="col-4">
                  <select id="advertiser-ccode" name="ccode" value={editUser?.ccode} onChange={handleInput} className="form-select mb-3 custom-placeholder border border-1 theme-border-color theme-text-color" defaultValue={editUser?.ccode} >
                    {defaultData?.country?.map((item, index) => {
                      return (
                        <option
                          key={index}
                          value={item?.phonecode}
                          className="theme-bg-color theme-text-color"
                        >
                          {item?.country_name}-({item?.phonecode})
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-8 ms-2">
                  <AdminCustomInput type="number" id="advertiser-mobile" name="mobile_number" min={0} value={editUser?.mobile_number} placeHolder={"Enter mobile number"} onChange={handleInput} error={formErrors?.mobile_number} />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="col-4">
                  {formErrors?.ccode && (<MessageBox text={`${formErrors?.ccode}`} classname='errorred mb-2 d-block' />)}
                </div>
              </div>
            </div>

            <MessageLabel text={"License Number"} />
            <AdminCustomInput
              type="text"
              name="license_number"
              value={editUser.license_number}
              onChange={handleInput}
              placeHolder={"Enter License Number"}
              id={"advertiser-license"}
            />

            <MessageLabel text={"Address"} />
            <AdminCustomInput
              type="textarea"
              name="address"
              value={editUser.address}
              onChange={handleInput}
              placeHolder={"Enter Address"}
              id={"advertiser-address"}
            />
          </Wrapper>

          <Wrapper>
            <MessageHeading text={"Status"} />
            <div className="d-flex justify-content-between mb-2">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Status"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch
                  name="status"
                  checked={editUser.status === 1}
                  id={"advertiser-status"}
                  onChange={handleInput}
                />
              </div>
            </div>

          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
};

export default EditAdsCategories;